// کاتالوگ Entitlement برای ویرایشگر نسخه پلن و استثنا (PRD-PLT §9؛ همان EntitlementCatalog سرور — C-AGENT-202).
// API کاتالوگ جدا ندارد؛ کلید ناشناخته را سرور با PHX-PLT-0202/0601 رد می‌کند و Featureهای موجود در نسخه‌ها هم افزوده می‌شوند.

/** Featureهای قابل فروش به تفکیک ماژول (BR-PLT-041: الزام قانونی‌ها کلید پلن نیستند). */
export const FEATURE_GROUPS: readonly { module: string; features: readonly string[] }[] = [
  { module: 'sch', features: ['feature.sch.queue', 'feature.sch.marketplace_sync'] },
  { module: 'bil', features: ['feature.bil.bnpl', 'feature.bil.quotes'] },
  { module: 'cmp', features: ['feature.cmp.payouts', 'feature.cmp.provider_portal'] },
  { module: 'acc', features: ['feature.acc.full_ledger', 'feature.acc.cost_centers'] },
  { module: 'inv', features: ['feature.inv.inventory'] },
  { module: 'org', features: ['feature.org.devices'] },
  { module: 'eng', features: ['feature.eng.crm', 'feature.eng.loyalty', 'feature.eng.campaigns'] },
  { module: 'chn', features: ['feature.chn.kiosk', 'feature.chn.call_center', 'feature.chn.ticketing'] },
  { module: 'tel', features: ['feature.tel.virtual_visits'] },
  { module: 'int', features: ['feature.int.public_api'] },
  { module: 'rpt', features: ['feature.rpt.dashboard', 'feature.rpt.custom_reports'] },
  { module: 'plt', features: ['feature.plt.multi_branch'] },
];

/** Featureهای الزام قانونی (همیشه فعال؛ قابل حذف یا استثنا نیستند — BR-PLT-041). */
export const REGULATORY_FEATURES: readonly string[] = [
  'feature.ins.insurance',
  'feature.med.e_prescription',
  'feature.cat.rvu_tariff',
  'feature.iam.audit',
  'feature.plt.data_export',
];

/** Limit Keyهای الزامی هر نسخه پلن (AC-PLT-020.2). */
export const LIMIT_KEYS: readonly string[] = [
  'limit.branches',
  'limit.active_providers',
  'limit.staff_users',
  'limit.storage_gb',
  'limit.specialty_packs',
];

export const ALL_FEATURES: readonly string[] = FEATURE_GROUPS.flatMap((group) => group.features);

/** کلید i18n برچسب Limit (console:limit_key.branches). */
export function limitLabelKey(key: string): string {
  return `console:limit_key.${key.replace(/^limit\./, '')}`;
}

/** کلید i18n گروه ماژول (console:module.sch). */
export function moduleLabelKey(module: string): string {
  return `console:module.${module}`;
}
